import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class CanisterService {
    constructor(private httpClient: HttpClient) { }

    getCanistersBySurvey( canisterData: string ): Observable<any> {
        const params = new HttpParams();
        const url = ecorEnv.apiEndpoint + '/secure/pega/canisters?canisterData=' + encodeURIComponent(canisterData);
        return this.httpClient.get<any>(url, { params: params })
            .pipe(
                catchError(this.handleError)
            );
    }

    getResourceBase64(resourceId: string): Observable<any> {
        const url = ecorEnv.apiEndpoint + '/secure/pega/attachmentbase64/' + resourceId;
        return this.httpClient.get<any>(url, { responseType: 'text' as 'json' })
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('surveys-view-base', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('surveys-view-base', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
